/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Requirements_Fields_Os1Inputs */

const en_us2_offerdetail_requirements_fields_os1 = /** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS`)
};

const es_es2_offerdetail_requirements_fields_os1 = /** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SO`)
};

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const id_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const ms_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const da_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const de_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const es_mx2_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const fil_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const fr_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const it_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const hu_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const nl_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const no_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const pl_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const pt_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const pt_br2_offerdetail_requirements_fields_os1 = pt_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const ro_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const fi_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const sv_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const vi_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const tr_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const cs_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const bg_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const ru_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const uk_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const ar_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const hi_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const th_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const ja_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const zh_cn2_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const zh_hant1_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/** @type {(inputs: Offerdetail_Requirements_Fields_Os1Inputs) => LocalizedString} */
const ko_offerdetail_requirements_fields_os1 = en_us2_offerdetail_requirements_fields_os1;

/**
* | output |
* | --- |
* | "OS" |
*
* @param {Offerdetail_Requirements_Fields_Os1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_requirements_fields_os1 = /** @type {((inputs?: Offerdetail_Requirements_Fields_Os1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Requirements_Fields_Os1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_requirements_fields_os1(inputs)
	if (locale === "ms") return ms_offerdetail_requirements_fields_os1(inputs)
	if (locale === "da") return da_offerdetail_requirements_fields_os1(inputs)
	if (locale === "de") return de_offerdetail_requirements_fields_os1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_requirements_fields_os1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_requirements_fields_os1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_requirements_fields_os1(inputs)
	if (locale === "fil") return fil_offerdetail_requirements_fields_os1(inputs)
	if (locale === "fr") return fr_offerdetail_requirements_fields_os1(inputs)
	if (locale === "it") return it_offerdetail_requirements_fields_os1(inputs)
	if (locale === "hu") return hu_offerdetail_requirements_fields_os1(inputs)
	if (locale === "nl") return nl_offerdetail_requirements_fields_os1(inputs)
	if (locale === "no") return no_offerdetail_requirements_fields_os1(inputs)
	if (locale === "pl") return pl_offerdetail_requirements_fields_os1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_requirements_fields_os1(inputs)
	if (locale === "pt") return pt_offerdetail_requirements_fields_os1(inputs)
	if (locale === "ro") return ro_offerdetail_requirements_fields_os1(inputs)
	if (locale === "fi") return fi_offerdetail_requirements_fields_os1(inputs)
	if (locale === "sv") return sv_offerdetail_requirements_fields_os1(inputs)
	if (locale === "vi") return vi_offerdetail_requirements_fields_os1(inputs)
	if (locale === "tr") return tr_offerdetail_requirements_fields_os1(inputs)
	if (locale === "cs") return cs_offerdetail_requirements_fields_os1(inputs)
	if (locale === "bg") return bg_offerdetail_requirements_fields_os1(inputs)
	if (locale === "ru") return ru_offerdetail_requirements_fields_os1(inputs)
	if (locale === "uk") return uk_offerdetail_requirements_fields_os1(inputs)
	if (locale === "ar") return ar_offerdetail_requirements_fields_os1(inputs)
	if (locale === "hi") return hi_offerdetail_requirements_fields_os1(inputs)
	if (locale === "th") return th_offerdetail_requirements_fields_os1(inputs)
	if (locale === "ja") return ja_offerdetail_requirements_fields_os1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_requirements_fields_os1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_requirements_fields_os1(inputs)
	return ko_offerdetail_requirements_fields_os1(inputs)
});
export { offerdetail_requirements_fields_os1 as "offerDetail.requirements.fields.os" }